import React from 'react';

import { PurchaseOrderFooter } from './purchase-order-footer';
import { BasePurchaseOrderDrawer } from '../common/base-purchase-order-drawer';
import { messages } from '../messages';
import { usePurchaseOrderContext } from '../purchase-order-context';
import { PurchaseOrderDetails } from '../purchase-order-page/edit/purchase-order-details';
import { useSupplierById } from '../hooks/use-supplier-by-id';

/**
 * Purchase Order Drawer component for creating/editing purchase orders
 *  @param {object} props - Component props
 * @param {boolean} [props.isCreatingNew] boolean indicating whether drawer is used for creating new PO or editing existing one
 * @returns {JSX.Element} The CreatePurchaseOrderDrawer component
 */
export const PurchaseOrderDrawer = ({ isCreatingNew = true }) => {
  const { onClose, hasChanged, purchaseOrder } = usePurchaseOrderContext();
  const { supplier: currentSupplier, isLoading: isLoadingSupplier, refetch: refetchSupplier } = useSupplierById(purchaseOrder?.supplierId);

  const title = isCreatingNew
    ? messages.newPurchaseOrderDrawerHeaderText.defaultMessage
    : messages.editPurchaseOrderDrawerHeaderText.defaultMessage;

  return (
    <BasePurchaseOrderDrawer
      bodyComponent={
        <PurchaseOrderDetails currentSupplier={currentSupplier} isLoadingSupplier={isLoadingSupplier} refetchSupplier={refetchSupplier} />
      }
      footerComponent={<PurchaseOrderFooter isCreatingNew={isCreatingNew} purchaseOrderChanged={hasChanged} />}
      isCreatingNew={isCreatingNew}
      onClose={onClose}
      purchaseOrderChanged={hasChanged}
      testId='create-purchase-order'
      title={title}
    />
  );
};
